export const loanDurationOptionsDE = [
    {
        label: 'Kurzfristig: Nur ein paar Monate',
        value: 'few_months'
    },
    {
        label: 'Mittelfristig: 1-2 Jahre',
        value: 'one_to_two_years'
    },
    {
        label: 'Langfristig: 3-5 Jahre',
        value: 'three_plus_years'
    },
    {
        label: 'Flexibel: je nach Bedarf Geld abrufen',
        value: 'ongoing'
    }
];
